import { api } from './client'

/**
 * R3-27 (REQ-264-001) — matrice di approvazione generale per tipo di operazione, importo, settore e utente/ruolo.
 * Letture: Admin, Amministrazione, Commercialista; scritture: solo Admin. Attiva solo con il flag `approvazioni.matrice`.
 */
export type ApprovalLevel = 'Responsabile' | 'Amministrazione' | 'Direzione'

export const APPROVAL_LEVELS: { value: ApprovalLevel; label: string }[] = [
  { value: 'Responsabile', label: 'Responsabile' },
  { value: 'Amministrazione', label: 'Amministrazione' },
  { value: 'Direzione', label: 'Direzione' },
]

export const APPROVAL_OPERATIONS: { value: string; label: string }[] = [
  { value: 'spesa', label: 'Spesa' },
  { value: 'distinta_provvigioni', label: 'Distinta provvigioni' },
  { value: 'richiesta_prezzo', label: 'Richiesta di prezzo' },
  { value: 'storno', label: 'Storno' },
  { value: 'anticipo_socio', label: 'Anticipo socio' },
]

export interface ApprovalMatrixRule {
  id: number
  operation: string
  minAmount: number
  maxAmount: number | null
  sectorId: number | null
  requesterUserId: number | null
  requesterRole: string | null
  level: ApprovalLevel
  priority: number
  isActive: boolean
}

export interface ApprovalMatrixList {
  operations: string[]
  levels: ApprovalLevel[]
  defaults: { responsibleMax: number; administrationMax: number }
  items: ApprovalMatrixRule[]
}

export interface ApprovalMatrixRuleBody {
  operation: string
  minAmount: number
  maxAmount?: number | null | undefined
  sectorId?: number | null | undefined
  requesterUserId?: number | null | undefined
  requesterRole?: string | null | undefined
  level: ApprovalLevel
  priority: number
  isActive: boolean
}

export const approvalMatrixApi = {
  list: () => api<ApprovalMatrixList>('/api/approval-matrix'),
  create: (body: ApprovalMatrixRuleBody) =>
    api<{ id: number }>('/api/approval-matrix', { method: 'POST', body: JSON.stringify(body) }),
  update: (id: number, body: ApprovalMatrixRuleBody) =>
    api<void>(`/api/approval-matrix/${id}`, { method: 'PUT', body: JSON.stringify(body) }),
  remove: (id: number) => api<void>(`/api/approval-matrix/${id}`, { method: 'DELETE' }),
  seedDefaults: () => api<{ created: number }>('/api/approval-matrix/seed-defaults', { method: 'POST', body: '{}' }),
}
